import { createSlice } from '@reduxjs/toolkit'

interface StateSlice {
	imageRefrest: string
	categoryRefrest: boolean
	couponRefrest: boolean
	ordersRefrest: boolean
	contactRefrest: boolean
	sessionRefrest: boolean
	productsRefrest: boolean
	usersRefrest: boolean
	customersRefrest: boolean
	menuToggle: boolean
	menuOpen: boolean
}

const initialState: StateSlice = {
	imageRefrest: '',
	categoryRefrest: false,
	couponRefrest: false,
	sessionRefrest: false,
	contactRefrest: false,
	productsRefrest: false,
	usersRefrest: false,
	customersRefrest: false,
	menuToggle: false,
	ordersRefrest: false,
	menuOpen: false,
}

const stateSlice = createSlice({
	name: 'state',
	initialState,
	reducers: {
		imageRefrestUpdate: (state) => {
			state.imageRefrest = 'refresh'
		},
		removeImageRefrest: (state) => {
			state.imageRefrest = ''
		},
		categoryRefrestUpdate: (state) => {
			state.categoryRefrest = !state.categoryRefrest
		},
		usersRefrestUpdate: (state) => {
			state.usersRefrest = !state.usersRefrest
		},
		customersRefrestUpdate: (state) => {
			state.customersRefrest = !state.customersRefrest
		},
		ordersRefrestUpdate: (state) => {
			state.ordersRefrest = !state.ordersRefrest
		},
		contactRefrestUpdate: (state) => {
			state.categoryRefrest = !state.categoryRefrest
		},
		couponRefrestUpdate: (state) => {
			state.couponRefrest = !state.couponRefrest
		},
		sessionRefrestUpdate: (state) => {
			state.sessionRefrest = !state.sessionRefrest
		},
		productsRefrestUpdate: (state) => {
			state.productsRefrest = !state.productsRefrest
		},
		handleMenuToggle: (state) => {
			state.menuToggle = !state.menuToggle
		},
		handleMenuOpen: (state) => {
			state.menuOpen = !state.menuOpen
		},
	},
})

export const {
	imageRefrestUpdate,
	removeImageRefrest,
	ordersRefrestUpdate,
	categoryRefrestUpdate,
	usersRefrestUpdate,
	customersRefrestUpdate,
	couponRefrestUpdate,
	contactRefrestUpdate,
	sessionRefrestUpdate,
	productsRefrestUpdate,
	handleMenuOpen,
	handleMenuToggle,
} = stateSlice.actions

export default stateSlice.reducer
